import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function ProductsDropdown({ theme }) {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
const { t } = useTranslation();

  const brands = isArabic
    ? [
        { name: "فرود", path: "/brand/Farroad" },
        { name: "دورو", path: "/brand/Duro" },
        { name: "ثري-إيه", path: "/brand/Three-A" },
      ]
    : [
        { name: "Farroad", path: "/brand/Farroad" },
        { name: "Duro", path: "/brand/Duro" },
        { name: "Three-A", path: "/brand/Three-A" },
      ];

  return (
    <div className="products-dropdown">
      <button className="dropdown-toggle">{t('nav_products')}
</button>

      <ul className="dropdown-menu">
        {brands.map((brand) => (
          <li key={brand.name}>
            <Link to={brand.path}>{brand.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ProductsDropdown;
